module.exports = __webpack_public_path__ + "static/media/empty-state-recarga-programada-em-breve.305132d2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/empty-state-recarga-programada-em-breve.svg
// module id = 2907
// module chunks = 0